import declare from "dojo/_base/declare";
import NewSupplierRequest from "./NewSupplierRequest";

const NewFormulatedMaterialSupplierRequest = declare(NewSupplierRequest, {
	fixedType: "DataPackageContainerType:FormulatedMaterial",
	productField: "FormulatedMaterials",
});

export = NewFormulatedMaterialSupplierRequest;